<template>
  <!-- 工单详情 -->
  <div class="smy__card-full-box">
    <Card
      class=""
      :bordered="false"
      :padding="0"
      >
      <p slot="title">
        账户管理
      </p>
    </Card>
      <div class="content">
        <Card
          class="smy__card-full card-left"
          :bordered="false">
          <AgentManageLeft
            :accountDetail="accountDetail"
          />
        </Card>
        <div class="smy__card-full card-right">
          <AgentManageRight />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import AgentManageLeft from './AgentManageLeft'
import AgentManageRight from './AgentManageRight'

export default {
  components: {
    AgentManageLeft,
    AgentManageRight
  },
  data () {
    return {
      accountDetail: {}
    }
  },
  methods: {},
  created () {},
  beforeRouteEnter (to, from, next) {
    axios.get(`/agent/account/info`).then(res => {
      next(vm => {
        vm.accountDetail = res.data
      })
    })
  }
}
</script>

<style lang="less" scoped>
.content {
  margin-top: 10px;
  flex: 1;
  display: flex;
  .card-left {
    width: 300px;
    flex-shrink: 0;
  }

  .card-right {
    width: 100%;
    margin-left: 10px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agAgentManage/index.vue